export let MAILCHIMP_ACTION = {
    delete: "deleted",
    subscribe: "subscribed",
    unsubscribe: "unsubscribed"
};
